import React from 'react'
import styles  from './App.module.css'
import Header  from '@/components/layout/Header'
import Banner  from '@/components/layout/Banner'
import Footer  from '@/components/layout/Footer'
import HomePage from '@/pages/Home'

/**
 * App — Root application shell.
 *
 * Layout hierarchy:
 *   ┌────────────────────────────────┐
 *   │  Skip-to-content link           │  (accessibility)
 *   │  Header                         │
 *   │    └ TopBar                     │
 *   │    └ MainHeader (logo/search)   │
 *   │    └ NavBar (sticky)            │
 *   │  Banner (yellow strip)          │
 *   │  Main content (HomePage)        │
 *   │  Footer                         │
 *   └────────────────────────────────┘
 */
const App: React.FC = () => {
  return (
    <div className={styles.app}>
      {/* Accessibility: skip-to-content link */}
      <a href="#main-content" className={styles.skipLink}>
        Skip to main content
      </a>

      {/* ── Page Header ── */}
      <Header />

      {/* ── Banner Strip ── */}
      <Banner />

      {/* ── Page Content ── */}
      <HomePage />

      {/* ── Footer ── */}
      <Footer />
    </div>
  )
}

export default App

